module.exports = __webpack_public_path__ + "static/media/valor1.8710acf5.png";